<template>
  <div>
    <!-- Search input -->
    <div class="row no-gutters">
      <div class="search-bar col-6 p-0">
        <input
          class="form-control-lg search py-0"
          name="searchKeyword"
          v-model="searchKeyword"
          type="text"
          :placeholder="$tc(placeholder)"
          autocomplete="off"
        />
      </div>
    </div>

    <!-- Total results label -->
    <div class="results-count pt-4 pl-3" v-show="total">
      <span id="resultsCountNumber">{{ total }}</span>
      <span id="resultsText"> {{ $tc('nav.settings.nav.conditions.results', total) }}</span>
    </div>

    <!-- Conditions list -->
    <conditions-list-list-item :results=results :attributes="attributes" @delete="deleteCondition">
    </conditions-list-list-item>

    <!-- Pagination -->
    <core-pagination :page.sync="page" :pages.sync="pages" :pageSize.sync="pageSize" @update="getConditions"></core-pagination>
  </div>
</template>

<script>
import Conditions from '@/services/hatsApi/Conditions'

export default {
  data () {
    return {
      results: [],
      total: 0,
      attributes: ['name', 'content', 'id'],
      placeholder: 'nav.settings.nav.conditions.search-placeholder',
      // search conditions keyword
      searchKeyword: '',
      // pagination
      page: 1,
      pages: 1,
      pageSize: 10
    }
  },
  created: function () {
    this.debouncedSearch = this.$_.debounce(this.getConditions, 500)
    this.getConditions()
  },
  watch: {
    searchKeyword: function () {
      this.debouncedSearch()
    }
  },
  methods: {
    /**
     * Get all conditions
     * @param {void}
     * @returns {void}
     */
    async getConditions () {
      try {
        let filters = [
          {
            property: 'name',
            value: this.searchKeyword
          }
        ]
        const { data } = await Conditions.getConditions(filters, this.pageSize, this.page)
        if (this.page !== 1 && data.data.length === 0) {
          this.page = 1
          this.getConditions()
        } else {
          const conditions = data.data
          this.results = conditions
          this.total = data.total
          this.page = data.page
          this.pages = data.pages
        }
      } catch (e) {}
    },
    /**
     * Delete conditions by ID
     * @param {string | int} id
     * @returns {void}
     */
    async deleteCondition (id) {
      try {
        await Conditions.deleteConditions(id)
        this.getConditions()
      } catch (e) {}
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/conditions/Index.vue